/* globals canManageGeneralRisks */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

export default function GeneralDecision(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [decision, setDecision] = useState(null);

    useEffect(() => {
        fetchDataset();
    }, []);

    const fetchDataset = () => {
        setIsLoading(true);
        axios
            .get(fetchGeneralDecisionUrl)
            .then(({ data }) => {
                setDecision(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setIsLoading(false));
    };

    if (isLoading) {
        return <Loading />;
    } else if (!decision) {
        return <div className="text-danger">{$t('Something went wrong')}.</div>;
    }

    return (
        <div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('General Decision')}</h5>
                    <div className="row">
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Detailed description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.detailed_description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Owner')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {decision.owner?.first_name} {decision.owner?.last_name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Status')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.status?.title}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Priority')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.priority}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Target Decision Date')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.target_date}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Date Decision Made')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.date}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('No. of Actions')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.actions_count.total}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Actions - Completed')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.actions_count.completed}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Actions - Outstanding')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{decision.actions_count.outstanding}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('Inter-dependencies')}</h5>
                    {!decision.issues?.length && !decision.risks?.length ? (
                        <div>{$t('No Inter-dependencies')}</div>
                    ) : (
                        <table className="table table-sm table-bordered no-footer text-center m-0">
                            <thead>
                                <tr className="text-center font-weight-bold text-blue table__label_text">
                                    <th style={{ width: '10%' }}>{$t('Unique Reference')}</th>
                                    <th style={{ minWidth: '200px' }}>{$t('Description')}</th>
                                    <th>{$t('Type')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {decision.issues.map((issue) => (
                                    <InterDependencyRow
                                        row={issue}
                                        link={fetchGeneralIssueUrl.replace('GENERAL_ISSUE_ID', issue.id)}
                                        key={issue.id}
                                        type={$t('General Issue')}
                                    />
                                ))}
                                {decision.risks.map((risk) => (
                                    <InterDependencyRow
                                        row={risk}
                                        link={canManageGeneralRisks ? fetchGeneralRiskUrl.replace('GENERAL_RISK_ID', risk.id) : null}
                                        key={risk.id}
                                        type={$t('General Risk')}
                                    />
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

function Loading() {
    return (
        <div className="row my-2">
            <div className="col-12 d-flex align-items-center justify-content-center text-blue">
                <div
                    className="spinner-border"
                    style={{
                        width: '2rem',
                        height: '2rem',
                    }}
                    role="status"
                >
                    <span className="sr-only">{$t('Loading')}...</span>
                </div>
            </div>
        </div>
    );
}

/**
 * One related record in the Inter-dependencies table.
 *
 * A NULL `link` RENDERS THE DESCRIPTION AS TEXT, not as a dead anchor. The
 * related record's own page can refuse this user — `general-risks.show` is
 * gated on manage-general-risk, which is assignable independently of the
 * permission that got them onto this page — so the row still names the
 * dependency and simply does not pretend it can be opened. An `<a>` with no
 * href looks clickable and is not; one that 403s is worse.
 */
function InterDependencyRow({ row, link, type }) {
    return (
        <tr>
            <td>{row.id}</td>
            <td className="text-left">{link ? <a href={link}>{row.description}</a> : row.description}</td>
            <td>{type}</td>
        </tr>
    );
}

if (document.getElementById('generalDecisionShow')) {
    var root = document.getElementById('generalDecisionShow');
    ReactDOM.render(
        <App>
            <GeneralDecision />
        </App>,
        root,
    );
}
